export default {
  errorFailedToUploadFile: {
    id: 'asp_action_bar_attachments_failed_to_upload',
    defaultMessage: 'Failed to upload {filename}',
  },
}
